"use strict";

var Dropdown = require("app/shared/components/Dropdown/dropdown");
var AddTeamPrompt = require("app/shared/components/TeamSelector/add-team-prompt");
var _ = require("underscore");

var TeamSelector = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    options: React.PropTypes.arrayOf(React.PropTypes.object),
    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]).isRequired,
    handleOnChangeOptions: React.PropTypes.func.isRequired,
    shouldRenderPrompt: React.PropTypes.bool.isRequired,
    handleOnChangeName: React.PropTypes.func.isRequired,
    handleLeaderSelection: React.PropTypes.func.isRequired,
    handleMemberSelection: React.PropTypes.func.isRequired,
    teamName: React.PropTypes.string.isRequired,
    leaderSelection: React.PropTypes.arrayOf(React.PropTypes.object),
    memberSelection: React.PropTypes.arrayOf(React.PropTypes.object),
    onClosePrompt: React.PropTypes.func.isRequired,
    onConfirmPrompt: React.PropTypes.func.isRequired,
    className: React.PropTypes.string
  },
  render: function() {
    var promptProps = {
      isOpen: true,
      onClose: function(){
        this.props.onClosePrompt();
      }.bind(this),
      onConfirm: function(){
        this.props.onConfirmPrompt();
      }.bind(this),
      handleOnChangeName: this.props.handleOnChangeName,
      handleLeaderSelection: this.props.handleLeaderSelection,
      handleMemberSelection: this.props.handleMemberSelection,
      teamName: this.props.teamName,
      leaderSelection: this.props.leaderSelection,
      memberSelection: this.props.memberSelection
    };

    var options = this.props.options;
    var hasDefaultButtons =  _.findWhere(this.props.options, { name: "Nenhuma Equipe" }) && _.findWhere(this.props.options, { name: "+ Criar Equipe" });
    if ( !hasDefaultButtons && options) {
      options.unshift({ name: "Nenhuma Equipe" });
      options.push({ name: "+ Criar Equipe" });
    }

    return (
      <div className={this.props.className}>
        {
          this.props.shouldRenderPrompt
          ? <AddTeamPrompt {...promptProps} />
          : null
        }
        <Dropdown value={this.props.value}
          options={options}
          handleCustomChange={this.props.handleOnChangeOptions}
          className="pl-7 br-0 c-000 w-100pct"/>
      </div>
    );
  }
});

module.exports = TeamSelector;



// WEBPACK FOOTER //
// ./app/shared/components/TeamSelector/team-selector.jsx